import { TFunction } from "i18next"
import { useCallback } from "react"
import { useTranslation } from "react-i18next"
import { PredefinedSegmentGroups, SegmentGroupResponseDataSchema } from "schema"
import z from "zod"

// NOTE: Used in routes where hooks are not available
export function getPredefinedSegmentGroupsTranslation(t: TFunction) {
  return {
    [PredefinedSegmentGroups.satisfaction]: t("segments.predefined.kind.satisfaction.label"),
    [PredefinedSegmentGroups.country]: t("segments.predefined.kind.country.label"),
    [PredefinedSegmentGroups.language]: t("segments.predefined.kind.language.label"),
    [PredefinedSegmentGroups.companyClient]: t("segments.predefined.kind.companyClient.label"),
    [PredefinedSegmentGroups.purchaseRecency]: t("segments.predefined.kind.purchaseRecency.label"),
    [PredefinedSegmentGroups.rfm]: t("segments.predefined.kind.rfm.label"),
  }
}

export function usePredefinedSegmentGroupsTranslation() {
  const { t } = useTranslation()

  const getSegmentGroupTranslation = useCallback(
    (segmentGroup?: z.infer<typeof SegmentGroupResponseDataSchema>) => {
      if (segmentGroup?.isPredefined) {
        return getPredefinedSegmentGroupsTranslation(t)[
          segmentGroup.name as keyof typeof PredefinedSegmentGroups
        ]
      }

      return segmentGroup?.name
    },
    [t],
  )

  return { getSegmentGroupTranslation }
}
